'use client';

import React from 'react';
import { Paper, Typography, Box, PaperProps, useTheme, useMediaQuery } from '@mui/material';

export type MoCardProps = {
  title?: string;
  titleSuffix?: React.ReactNode;
  subtitle?: string;
  action?: React.ReactNode;
  padding?: string;
  useMobileStyles?: boolean;
  mobileBreakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
  children: React.ReactNode;
};

const Wrapper = ({
  padding = '2rem',
  children,
  useMobileStyles = false,
  mobileBreakpoint = 'sm',
  ...props
}: MoCardProps & PaperProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint));

  if (useMobileStyles && isMobile) return <Box mb={8}>{children}</Box>;

  return (
    <Paper {...props}>
      <Box padding={padding}>{children}</Box>
    </Paper>
  );
};

export function MoCard({
  title,
  titleSuffix,
  subtitle,
  action,
  children,
  ...props
}: MoCardProps & PaperProps) {
  return (
    <Wrapper {...props}>
      {(title || subtitle || action) && (
        <Box mb={3}>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
          >
            <Box sx={{ flex: '1 1 12rem', minWidth: 0 }}>
              {title && (
                <Typography variant="h3">
                  {title}
                  {titleSuffix && <> {titleSuffix}</>}
                </Typography>
              )}
              {subtitle && (
                <Box mt={title ? 1 : 0}>
                  <Typography variant="body2">{subtitle}</Typography>
                </Box>
              )}
            </Box>
            {action && <Box sx={{ marginLeft: 'auto' }}>{action}</Box>}
          </Box>
        </Box>
      )}
      {children}
    </Wrapper>
  );
}
